export const selectPmsNeedsSync = s => s.login.currentPmsNeedSync
export const selectIsInternalAdmin = s => s.login.isInternalAdmin
export const selectHotelWebsite = s => s.hotelDetails.primaryWebsiteUrl
export const selectPathName = s => s.router.location.pathname
export const selectCurrency = s => s.hotelDetails.currency
export const selectLocale = s => s.hotelDetails.locale
export const selectCurrentHotelId = s => s.login.currentHotelId
export const selectHotelList = s => s.login.subsidiaryList
export const selectInvoices = s => s.invoices
export const selectCurrentHotelName = s => s.hotelDetails.name
export const selectCurrentGroupName = s => s.hotelDetails.groupName
export const selectCurrentGroupId = s => s.hotelDetails.groupId
export const selectCurrentHotelBllingAddress = s => s.hotelDetails.billingAddress
export const selectCurrentHotelPMS = s => s.login.subsidiaryPMS
export const selectLoggedinUserName = s => s.login.currentUser.name
export const selectLoggedinUserPhone = s => s.login.currentUser.phone
export const selectLoggedinUserEmail = s => s.login.currentUser.email
export const selectCurrentBalance = s => s.billing.currentBalance
export const selectIsInvoiceGroupView = s => s.billing.isGroupView
export const selectChatIntentTypes = s => s.chatBotTraining.intentTypes
export const selectCurrentHotels = s => s.login.subsidiaryList
export const selectNotifications = s => s.notifications.notificationList
export const selectGotNotificationsList = s => s.notifications.gotNotificationsList
export const selectNotificationPreferences = s => s.notifications.notificationPreferences
export const selectSubsidiaryIdForSingleInvoice = s =>
  s.invoices.subsidiaryIdForSingleInvoice

// email logs

export const selectInvoiceEmails = s => s.emailLogs.emails.invoice
export const selectLoginEmails = s => s.emailLogs.emails.login
export const selectInviteEmails = s => s.emailLogs.emails.invite
export const selectIncomingEmails = s => s.emailLogs.emails.incoming
